import { useState, useRef } from 'react';
import { IconButton, Stack, Typography } from '@mui/material';
import { Facebook, Instagram, Language, MailOutline, YouTube, Home } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import LanguageSelector from './LanguageSelector';
import { useSelector } from 'react-redux';
import { RootState } from 'store/types';

interface SocialsBarProps {
    open: boolean;
    email?: string;
}

const SocialsBar = (porps: SocialsBarProps) => {
    const navigate = useNavigate();
    const { open, email } = porps;
    const anchorRef = useRef(null);
    const { language } = useSelector((state: RootState) => state.customization);
    const [openLanguageMenu, setOpenLanguageMenu] = useState<boolean>(false);

    const goToHomePage = () => {
        navigate('/home');
    };

    const handleSendEmail = () => {
        window.open(`mailto:${email}`, '_blank');
    };

    const handleOpenLanguage = () => {
        setOpenLanguageMenu((prev) => !prev);
    };

    const languageToString = (language: 'gre' | 'en') => {
        if (language === 'gre') {
            return 'ΕΛ';
        }
        if (language === 'en') {
            return 'EN';
        }
        return '';
    };

    return (
        <Stack direction="row" alignItems="center" spacing={0.25} sx={{ opacity: open ? 1 : 0, transition: 'opacity 0.2s ease' }}>
                <IconButton aria-label="Home" size="small" onClick={goToHomePage} sx={{ p: 0.5 }}>
                    <Home sx={{ color: '#f0f0f0', fontSize: 18 }} />
                </IconButton>
                <IconButton aria-label="Facebook" size="small" sx={{ p: 0.5 }}>
                    <Facebook sx={{ color: '#f0f0f0', fontSize: 18 }} />
                </IconButton>
                <IconButton aria-label="Instagram" size="small" sx={{ p: 0.5 }}>
                    <Instagram sx={{ color: '#f0f0f0', fontSize: 18 }} />
                </IconButton>
                <IconButton aria-label="YouTube" size="small" sx={{ p: 0.5 }}>
                    <YouTube sx={{ color: '#f0f0f0', fontSize: 18 }} />
                </IconButton>
                <IconButton aria-label="Email" size="small" onClick={handleSendEmail} sx={{ p: 0.5 }}>
                    <MailOutline sx={{ color: '#f0f0f0', fontSize: 18 }} />
                </IconButton>
                <IconButton aria-label="Language" size="small" onClick={handleOpenLanguage} ref={anchorRef} sx={{ p: 0.5 }}>
                    <Stack direction="row" spacing={0.5} alignItems="center">
                        <Language sx={{ color: '#f0f0f0', fontSize: 18 }} />
                        <Typography fontSize="0.78rem" sx={{ color: '#f0f0f0', fontFamily: 'Inter', fontWeight: 700 }}>
                            {languageToString(language)}
                        </Typography>
                    </Stack>
                    <LanguageSelector anchorRef={anchorRef} open={openLanguageMenu} setOpen={setOpenLanguageMenu} language={language} />
                </IconButton>
        </Stack>
    );
};

export default SocialsBar;
